import { Link } from "@tanstack/react-router";
import { VersionTag } from "./VersionTag";

/** Quiet footer shared by the public pages. */
export function SiteFooter({ width = "max-w-5xl" }: { width?: string }) {
	return (
		<footer className="border-t border-line">
			<div
				className={`mx-auto flex flex-wrap items-center justify-between gap-x-6 gap-y-2 px-4 py-5 text-[13px] text-muted sm:px-6 ${width}`}
			>
				<span>Solberegning er laget i Norge</span>
				<nav className="flex items-center gap-4" aria-label="Bunntekst">
					<Link to="/pricing" className="hover:text-ink">
						Priser
					</Link>
					<Link to="/account" hash="steder" className="hover:text-ink">
						Mine steder
					</Link>
					<VersionTag className="text-faint" />
				</nav>
			</div>
		</footer>
	);
}
